export interface DetectedObject {
  class: string;
  score: number;
  aspectRatio: number;
  objectArea: number;
  x: number;
  y: number;
  width: number;
  height: number;
}